import {
  Avatar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tooltip,
  Typography,
} from "@material-ui/core";
import {
  Close,
  CloudUpload,
  Delete,
  Image,
  InsertDriveFile,
  Link,
} from "@material-ui/icons";
import moment from "moment";
import { useEffect, useState, useRef } from "react";
import { getAddressDetails } from "../../../containers/User/AddressBook/actions";
import { getCurrentUserId } from "../../../utils";
import { CounterPartySelect } from "../../Common/CounterPartySelection";
const initialVesselContractField = [
  { id: "vesselFixtureId", label: "Vessel Fixture ID", type: "text" },
  { id: "estId", label: "Estimation ID", type: "text", readOnly: true },
  { id: "contractName", label: "Contract Name", type: "text", required: true },
  { id: "cpDate", label: "CP Date", type: "date", required: true },
  { id: "counterParty", label: "Counter Party Full Style", type: "text" },
  { id: "bankingDetails", label: "Banking Details", type: "text" },
  { id: "contractingCompany", label: "Contracting Company", type: "text", required: true },
  { id: "department", label: "Department", type: "text" },
  { id: "tradeArea", label: "Trade Area", type: "text" },
  { id: "vesselType", label: "Vessel Type", type: "text" },
  {
    id: "currency",
    label: "Currency",
    type: "text",
    pattern: "[A-Z]{3}",
    title: "3-letter currency code",
  },
  { id: "shipmentNo", label: "Shipment No.", type: "number", min: 1 },
  { id: "charteringPIC", label: "Chartering PIC", type: "text", required: true },
  { id: "opsCoordinator", label: "Ops Coordinator", type: "text" },
];

export const CounterPartyList = ({
  title,
  field,
  placeholder,
  getAvailableCounterParties,
  formDataList,
  updateItem,
  onCounterPartyAdded,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openSelectionModal = () => {
    setIsModalOpen(true);
  };

  const handleCounterPartyChange = (value) => {
    updateItem(field, value);
  };

  const handleRemoveCounterParty = (id) => {
    const updatedList = formDataList.filter((item) => item.id !== id).map((item) => item.id);
    updateItem(field, updatedList);
  };

  return (
    <div className="flex-1 border border-[#cbd5e1] rounded-none min-h-[42px] p-1 scroll-thin bg-slate-50/50">
      {/* Header */}
      <div className="flex justify-between items-center mb-0.5 px-0.5">
        <h2 className="text-[11px] font-medium text-slate-700">
          {title?.endsWith(" *") ? (
            <>
              {title.slice(0, -2)}{" "}
              <span className="text-rose-500">*</span>
            </>
          ) : (
            title
          )}
        </h2>
        {
          formDataList && formDataList?.length > 0 && (
            <button
              type="button"
              onClick={openSelectionModal}
              className="bg-[#1e293b] text-white inline-flex items-center px-1.5 py-0.5 text-[11px] font-medium rounded-none hover:bg-[#0f172a] transition-colors"
            >
              <svg
                className="w-2.5 h-2.5 mr-0.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 4v16m8-8H4"
                />
              </svg>
              Select
            </button>
          )
        }
      </div>

      {/* Selected Items */}
      {formDataList && formDataList?.length > 0 ? (
        <div className="flex flex-col gap-0.5 max-h-[100px] overflow-y-auto px-0.5 scroll-thin">
          {formDataList.map((item) => (
            <div
              key={item.id}
              className="flex justify-between items-center border border-[#cbd5e1] rounded-none px-1.5 py-0 bg-[#ffffd6] hover:bg-white transition shadow-none"
            >
              <div className="flex flex-col text-[11px] leading-tight">
                <span className="font-medium text-slate-800">
                  {item.name} <span className="text-slate-500 font-medium">({item.type})</span>
                </span>
              </div>
              <button
                type="button"
                onClick={() => handleRemoveCounterParty(item.id)}
                className="text-slate-400 hover:text-rose-500 rounded-full transition ml-2 text-[11px]"
                aria-label="Remove"
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex justify-center items-center py-1 text-slate-400 text-[11px] border border-dashed border-[#cbd5e1] rounded-none bg-white">
          <button
            type="button"
            onClick={openSelectionModal}
            className="bg-[#1e293b] text-white inline-flex items-center justify-center w-[140px] py-0.5 text-[11px] font-medium rounded-none shadow-none hover:bg-[#0f172a] transition-colors"
          >
            <svg
              className="w-2.5 h-2.5 mr-0.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4v16m8-8H4"
              />
            </svg>
            {placeholder}
          </button>
        </div>
      )}

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-none shadow-xl w-full max-w-4xl p-2 border border-slate-300">
            <div className="flex items-center justify-end mb-1">
              <button
                className="text-gray-500 text-xs hover:text-rose-500 rounded-full transition p-1"
                onClick={() => setIsModalOpen(false)}
                aria-label="Close"
                type="button"
              >
                ✕
              </button>
            </div>

            <div className="px-2">
              <CounterPartySelect
                value={formDataList?.map((cp) => cp.id) || []}
                onChange={(e) => handleCounterPartyChange(e.target.value)}
                counterPartyDetails={getAvailableCounterParties}
                isMultiSelect={true}
                onCounterPartyAdded={onCounterPartyAdded}
              />
            </div>

            {/* Footer */}
            <div className="flex justify-end mt-2 px-2 pb-1">
              <button
                type="button"
                className="px-3 py-0.5 text-[11px] rounded-none bg-[#1e293b] text-white hover:bg-[#0f172a] font-medium transition"
                onClick={() => setIsModalOpen(false)}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const VesselContractForm = ({
  isReadOnly = false,
  formData,
  setFormData,
  textContract,
  setTextContract,
  attachments,
  handleChange,
  removeAttachment,
  handleAttachmentUpload,
  handleTextContractUpload,
  isEditing = false,
  setPrevAttachments,
  prevAttachments,
  isVesselVesselOps,
  isVesselVessel
}) => {

  const [counterPartyDetails, setCounterPartyDetails] = useState();
  const [organizationAddressBook, setOrganizationAddressBook] = useState([]);

  const textContractInputRef = useRef(null);
  const attachmentInputRef = useRef(null);

  const fetchCounterPartyDetails = async () => {
    const userId = getCurrentUserId();

    try {
      const [userRes, orgRes] = await Promise.all([
        getAddressDetails({ userId, addressBookType: "user", perPage: 100 }),
        getAddressDetails({ userId, addressBookType: "organization", perPage: 100 }),
      ]);

      setCounterPartyDetails(userRes?.data?.list);
      setOrganizationAddressBook(orgRes?.data?.list);
    } catch (error) {
      console.error("Failed to fetch counter party details:", error);
      setCounterPartyDetails([]);
      setOrganizationAddressBook([]);
    }
  };


  useEffect(() => {
    fetchCounterPartyDetails();
  }, []);

  const [isAttachmentModalOpen, setIsAttachmentModalOpen] = useState(false);

  // Utility to get file extension
  const getFileExtension = (url) => {
    try {
      const pathname = new URL(url).pathname;
      return pathname.substring(pathname.lastIndexOf(".")).toLowerCase();
    } catch {
      return "";
    }
  };

  const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
  const videoExtensions = [".mp4", ".mov", ".avi", ".wmv", ".flv", ".mkv"];

  // Type checks
  const isImageFile = (url) => {
    const ext = getFileExtension(url);
    return imageExtensions.includes(ext);
  };

  const isVideoFile = (url) => {
    const ext = getFileExtension(url);
    return videoExtensions.includes(ext);
  };

  // Combine all attachments (array + textContract if it exists)
  const allFiles = [
    ...(prevAttachments?.attachments || []),
    ...(prevAttachments?.textContract ? [prevAttachments.textContract] : []),
  ];

  // File counts
  const imageCount = allFiles.filter((url) => isImageFile(url)).length;
  const videoCount = allFiles.filter((url) => isVideoFile(url)).length;
  const fileCount = allFiles.filter(
    (url) => !isImageFile(url) && !isVideoFile(url)
  ).length;

  const addItemAtIndex = (field, index) => {
    setFormData((prev) => {
      // 1. Determine the source array based on the flag
      const currentList = isVesselVessel
        ? prev[prev.type]?.[field]
        : prev[field];

      const updated = [...(currentList ?? [])];
      updated.splice(index + 1, 0, { name: "", type: "", id: "" });

      // 2. Return structure based on the flag
      if (isVesselVessel) {
        return {
          ...prev,
          [prev.type]: {
            ...prev[prev.type],
            [field]: updated,
          },
        };
      }

      return { ...prev, [field]: updated };
    });
  };

  const updateItem = (field, values) => {
    const counterParty =
      field === "organizationAddress"
        ? organizationAddressBook
        : counterPartyDetails;

    setFormData((prev) => {
      // Map selected ids to objects
      const updatedList = values.map((id) => {
        const cp = counterParty?.find((item) => item._id === id);
        return {
          id,
          name:
            cp?.type === "Individual"
              ? `${cp?.individual_firstName || ""} ${cp?.individual_lastName || ""
                }`.trim() ||
              cp?.fullName ||
              "Unknown"
              : cp?.organisation_fullName ||
              `${cp?.organisation_firstName || ""} ${cp?.organisation_lastName || ""
              }` ||
              cp?.fullName ||
              "Unknown",
          type: cp?.type || "",
        };
      });

      // Return structure based on the flag
      if (isVesselVessel) {
        return {
          ...prev,
          [prev.type]: {
            ...prev[prev.type],
            [field]: updatedList,
          },
        };
      }

      return { ...prev, [field]: updatedList };
    });
  };

  const deleteItemAtIndex = (field, index) => {
    setFormData((prev) => {
      // 1. Determine the source array based on the flag
      const currentList = isVesselVessel
        ? prev[prev.type]?.[field] ?? []
        : prev[field] ?? [];

      if (currentList.length <= 1) return prev;

      const updated = [...currentList];
      updated.splice(index, 1);

      // 2. Return structure based on the flag
      if (isVesselVessel) {
        return {
          ...prev,
          [prev.type]: {
            ...prev[prev.type],
            [field]: updated,
          },
        };
      }

      return { ...prev, [field]: updated };
    });
  };

  return (
    <form className="space-y-2 bg-white text-slate-800">
      {/* 1. Top Input Grid - Excel Sheet Style Box */}
      <div className="border border-[#cbd5e1] rounded-none bg-white overflow-hidden shadow-none">
        <div className="bg-[#e2e8f0] px-2 py-1 border-b border-[#cbd5e1]">
          <h2 className="text-[11px] font-medium text-slate-800">
            Vessel Contract Information
          </h2>
        </div>
        <table className="block md:table w-full border-collapse text-left table-fixed">
          <tbody className="grid grid-cols-[40%_60%] md:table-row-group [&>tr:last-child>td:nth-last-child(-n+2)]:border-b-0">
            {Array.from({ length: Math.ceil(initialVesselContractField.length / 2) }).map((_, rowIndex) => {
              const field1 = initialVesselContractField[rowIndex * 2];
              const field2 = initialVesselContractField[rowIndex * 2 + 1];

              const renderFieldPair = (field, isRightField) => {
                if (!field) return <><td className="bg-white border-r border-b md:border-b-0 border-[#cbd5e1] min-h-[24px]" /><td className="bg-white border-b md:border-b-0 min-h-[24px]" /></>;
                const isDisabled = isReadOnly || field.readOnly;
                return (
                  <>
                    <td className="flex items-center md:table-cell min-h-[24px] md:min-h-0 border-r border-b md:border-b-0 border-[#cbd5e1] px-1.5 py-0 text-[11px] font-medium text-slate-900 bg-white w-auto md:w-[18%] align-middle md:truncate">
                      {field.label} {field.required && <span className="text-rose-500">*</span>}
                    </td>
                    <td className={`${isRightField ? "" : "border-r"} flex items-center md:table-cell min-h-[24px] md:min-h-0 border-b md:border-b-0 border-[#cbd5e1] p-0 align-middle ${isDisabled ? "bg-slate-100" : "bg-[#ffffd6]"} w-auto md:w-[32%]`}>
                      <input
                        type={field.type || "text"}
                        name={field.id}
                        value={
                          field.type === "date"
                            ? formData?.[field.id] && moment(formData[field.id]).isValid()
                              ? moment(formData[field.id]).format("YYYY-MM-DD")
                              : ""
                            : formData?.[field.id] ?? ""
                        }
                        onChange={handleChange}
                        className={`${field.type === "date" ? "w-fit max-w-full inline-flex items-center cursor-pointer" : "w-full block"} h-full min-h-[18px] px-1.5 py-0 m-0 box-border text-[11px] font-medium bg-transparent border-none outline-none ${
                          isDisabled
                            ? "text-slate-500 cursor-not-allowed"
                            : "text-slate-900 focus:bg-white focus:ring-1 focus:ring-inset focus:ring-amber-600"
                        }`}
                        required={field.required}
                        min={field.min}
                        max={field.max}
                        step={field.step}
                        pattern={field.pattern}
                        title={field.title}
                        disabled={isDisabled}
                      />
                    </td>
                  </>
                );
              };

              return (
                <tr key={rowIndex} className="contents md:table-row md:border-b border-[#cbd5e1] last:border-b-0 hover:bg-[#ffffcc]/60 transition-colors">
                  {renderFieldPair(field1, false)}
                  {renderFieldPair(field2, true)}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* 2. Counter Party & Address Book Row */}
      <div className={`grid gap-2 ${isVesselVesselOps ? "grid-cols-1" : "grid-cols-1 lg:grid-cols-2"}`}>
        {/* Counter Party Box */}
        <div className="w-full bg-white border border-[#cbd5e1] rounded-none overflow-hidden">
          <div className="bg-[#e2e8f0] px-2 py-1 border-b border-[#cbd5e1]">
            <h2 className="text-[11px] font-medium text-slate-800">
              Counter Party Details
            </h2>
          </div>
          <div className="p-2 flex flex-col md:flex-row gap-2 bg-slate-50/20">
            <CounterPartyList
              title="Counter Party Details *"
              placeholder="Select Counter Party"
              hasData={counterPartyDetails?.length > 0}
              list="counter parties"
              formDataList={formData?.counterPartyNames}
              field="counterPartyNames"
              getAvailableCounterParties={counterPartyDetails}
              addItem={addItemAtIndex}
              updateItem={updateItem}
              deleteItem={deleteItemAtIndex}
              createPath="/addressBook"
              onCounterPartyAdded={fetchCounterPartyDetails}
            />
            <CounterPartyList
              title="Brokers *"
              placeholder="Select Broker"
              hasData={counterPartyDetails?.length > 0}
              list="brokers"
              formDataList={formData?.brokers}
              field="brokers"
              getAvailableCounterParties={counterPartyDetails}
              addItem={addItemAtIndex}
              updateItem={updateItem}
              deleteItem={deleteItemAtIndex}
              createPath="/addressBook"
              onCounterPartyAdded={fetchCounterPartyDetails}
            />
          </div>
        </div>

        {/* Address Book Box */}
        {!isVesselVesselOps && (
          <div className="w-full bg-white border border-[#cbd5e1] rounded-none overflow-hidden">
            <div className="bg-[#e2e8f0] px-2 py-1 border-b border-[#cbd5e1]">
              <h2 className="text-[11px] font-medium text-slate-800">
                Address Book Details
              </h2>
            </div>
            <div className="p-2 flex flex-col md:flex-row gap-2 bg-slate-50/20">
              <CounterPartyList
                title="My Address Book"
                placeholder="Select Address Book"
                hasData={counterPartyDetails?.length > 0}
                list="my address books"
                formDataList={formData?.myAddressBook}
                field="myAddressBook"
                getAvailableCounterParties={counterPartyDetails}
                addItem={addItemAtIndex}
                updateItem={updateItem}
                deleteItem={deleteItemAtIndex}
                createPath="/addressBook"
                onCounterPartyAdded={fetchCounterPartyDetails}
              />
              <CounterPartyList
                title="Organization Address"
                placeholder="Select Org Address"
                hasData={organizationAddressBook?.length > 0}
                list="organization address books"
                formDataList={formData?.organizationAddress}
                field="organizationAddress"
                getAvailableCounterParties={organizationAddressBook}
                addItem={addItemAtIndex}
                updateItem={updateItem}
                deleteItem={deleteItemAtIndex}
                createPath="/addressBook"
                onCounterPartyAdded={fetchCounterPartyDetails}
              />
            </div>
          </div>
        )}
      </div>

      {/* 3. Attachments & Comments Section */}
      <div className="border border-[#cbd5e1] rounded-none bg-white overflow-hidden shadow-none">
        <div className="bg-[#e2e8f0] px-2 py-1 border-b border-[#cbd5e1]">
          <h2 className="text-[11px] font-medium text-slate-800">
            {isEditing ? "Attachments & Comments" : "Files & Comments"}
          </h2>
        </div>

        <div className="p-2 grid grid-cols-1 lg:grid-cols-2 gap-3 bg-slate-50/20">
          {/* Left Column - File Uploads */}
          <div className="space-y-2">
            {isEditing && (
              <div
                onClick={() => setIsAttachmentModalOpen(true)}
                className="inline-flex items-center border border-blue-500 text-blue-600 text-[11px] px-2 py-0.5 rounded-none bg-blue-50/50 cursor-pointer hover:bg-blue-100 transition font-medium"
              >
                <Link fontSize="small" className="mr-1" />
                Media: {imageCount} Images, {videoCount} Videos, {fileCount} Files
              </div>
            )}

            <div className="space-y-1.5 flex flex-col">
              {/* Text Contract Row */}
              <div className="flex items-center gap-2">
                <div className="w-1/3">
                  <span className="text-[11px] font-medium text-slate-700 block">
                    Text Contract
                  </span>
                  <span className="text-[11px] text-slate-500 leading-tight block">
                    PDF, DOC (Max 10MB)
                  </span>
                </div>
                <div className="w-2/3 flex items-center flex-wrap gap-1.5">
                  <input
                    accept=".pdf,.doc,.docx"
                    className="hidden"
                    id="text-contract-upload"
                    type="file"
                    ref={textContractInputRef}
                    disabled={isReadOnly}
                    onChange={handleTextContractUpload}
                  />
                  <Button
                    variant="contained"
                    size="small"
                    startIcon={<CloudUpload className="text-white" style={{ fontSize: '12px' }} />}
                    disabled={isReadOnly}
                    onClick={() => textContractInputRef.current?.click()}
                    className="!w-[115px] !min-w-[115px] !max-w-[115px]"
                    style={{ textTransform: 'none', padding: '1px 8px', fontSize: '11px', fontWeight: '500', height: '22px', backgroundColor: '#1e293b', color: '#fff', borderRadius: '0px', width: '115px', minWidth: '115px', maxWidth: '115px', justifyContent: 'center', whiteSpace: 'nowrap' }}
                  >
                    Upload
                  </Button>
                  {textContract && (
                    <div className="flex items-center bg-[#ffffd6] border border-[#cbd5e1] rounded-none px-1.5 py-0.5 max-w-[180px]">
                      <InsertDriveFile style={{ fontSize: '12px' }} className="text-gray-500 mr-1" />
                      <span className="text-[11px] font-medium text-slate-800 truncate max-w-[100px] mr-1">
                        {textContract.name}
                      </span>
                      <IconButton
                        size="small"
                        onClick={() => setTextContract(null)}
                        className="text-rose-500 hover:text-rose-700 p-0.5"
                      >
                        <Delete style={{ fontSize: '12px' }} />
                      </IconButton>
                    </div>
                  )}
                </div>
              </div>

              {/* Additional Attachments Row */}
              <div className="flex items-start gap-2">
                <div className="w-1/3">
                  <span className="text-[11px] font-medium text-slate-700 block">
                    Attachments
                  </span>
                  <span className="text-[11px] text-slate-500 leading-tight block">
                    PDF, JPG, PNG (Max 5MB)
                  </span>
                </div>
                <div className="w-2/3 flex flex-col items-start gap-1">
                  <input
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                    className="hidden"
                    id="attachment-upload"
                    multiple
                    type="file"
                    ref={attachmentInputRef}
                    disabled={isReadOnly}
                    onChange={handleAttachmentUpload}
                  />
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<CloudUpload style={{ fontSize: '12px' }} />}
                    disabled={isReadOnly}
                    onClick={() => attachmentInputRef.current?.click()}
                    className="!w-[115px] !min-w-[115px] !max-w-[115px]"
                    style={{ textTransform: 'none', padding: '1px 8px', fontSize: '11px', fontWeight: '500', height: '22px', borderRadius: '0px', borderColor: '#cbd5e1', width: '115px', minWidth: '115px', maxWidth: '115px', justifyContent: 'center', whiteSpace: 'nowrap' }}
                  >
                    Upload More
                  </Button>

                  {attachments?.length > 0 && (
                    <div className="flex flex-wrap gap-1 mt-0.5">
                      {attachments.map((file, index) => (
                        <Chip
                          key={index}
                          size="small"
                          icon={
                            file.type.includes("image") ? (
                              <Image style={{ fontSize: '12px', marginLeft: '2px' }} />
                            ) : (
                              <InsertDriveFile style={{ fontSize: '12px', marginLeft: '2px' }} />
                            )
                          }
                          label={
                            <Tooltip title={`${file.name} - ${(file.size / 1024).toFixed(2)} KB`}>
                              <span className="truncate max-w-[90px] text-[11px] font-medium">
                                {file.name}
                              </span>
                            </Tooltip>
                          }
                          onDelete={() => removeAttachment(index)}
                          deleteIcon={
                            <Delete
                              style={{ fontSize: '12px' }}
                              className="text-rose-500 hover:text-rose-700"
                              onMouseDown={(e) => e.stopPropagation()}
                            />
                          }
                          className="bg-[#ffffd6] border border-[#cbd5e1] rounded-none"
                          variant="outlined"
                        />
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Comments */}
          <div className="flex flex-col">
            <span className="text-[11px] font-medium text-slate-700 mb-0.5">
              Comments
            </span>
            <textarea
              name="comments"
              value={formData.comments || ""}
              onChange={handleChange}
              rows={3}
              disabled={isReadOnly}
              placeholder="Enter your comments here..."
              className="w-full px-1.5 py-1 text-[11px] font-medium border border-[#cbd5e1] rounded-none bg-[#ffffd6] focus:bg-white focus:outline-none focus:ring-1 focus:ring-inset focus:ring-amber-600 resize-none font-sans"
            />
          </div>
        </div>
      </div>

      {/* Attachments Modal for Edit Mode */}
        <Dialog
          open={isAttachmentModalOpen}
          onClose={() => setIsAttachmentModalOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle style={{ padding: '12px 16px' }}>
            <div className="flex justify-between items-center text-sm font-semibold">
              <span>Attachments</span>
              <IconButton size="small" onClick={() => setIsAttachmentModalOpen(false)}>
                <Close fontSize="small" />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent dividers style={{ padding: '8px 16px' }}>
            {prevAttachments?.attachments?.length > 0 ||
              prevAttachments?.textContract ? (
              <List disablePadding>
                {/* Text Contract */}
                {prevAttachments?.textContract && (
                  <Box>
                    <ListItem alignItems="center" style={{ padding: '4px 0' }}>
                      <ListItemAvatar style={{ minWidth: '40px' }}>
                        <Avatar
                          variant="rounded"
                          className="bg-gray-100 text-gray-600"
                          style={{ width: '30px', height: '30px' }}
                        >
                          <InsertDriveFile fontSize="small" />
                        </Avatar>
                      </ListItemAvatar>

                      <ListItemText
                        primary={
                          <a
                            href={prevAttachments.textContract}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue underline text-[11px]"
                          >
                            Open Contract File
                          </a>
                        }
                        secondary={
                          <Typography variant="caption" color="textSecondary" className="text-[10px] truncate max-w-[200px] block">
                            {prevAttachments.textContract.split("/").pop()}
                          </Typography>
                        }
                        style={{ margin: 0 }}
                      />

                      <IconButton
                        size="small"
                        edge="end"
                        onClick={() =>
                          setPrevAttachments((prev) => ({
                            ...prev,
                            textContract: null,
                          }))
                        }
                        className="text-rose-500 hover:text-rose-700"
                      >
                        <Delete fontSize="small" />
                      </IconButton>
                    </ListItem>

                    {prevAttachments?.attachments?.length > 0 && <Divider className="my-1" />}
                  </Box>
                )}

                {/* Additional Attachments */}
                {prevAttachments?.attachments?.map((url, index) => {
                  const isImage = isImageFile(url);

                  return (
                    <Box key={index}>
                      <ListItem alignItems="center" style={{ padding: '4px 0' }}>
                        <ListItemAvatar style={{ minWidth: '40px' }}>
                          {isImage ? (
                            <Avatar
                              variant="rounded"
                              src={url}
                              alt={`Attachment ${index}`}
                              className="cursor-pointer"
                              style={{ width: '30px', height: '30px' }}
                              onClick={() => window.open(url, "_blank")}
                            />
                          ) : (
                            <Avatar
                              variant="rounded"
                              className="bg-gray-100 text-gray-600"
                              style={{ width: '30px', height: '30px' }}
                            >
                              <InsertDriveFile fontSize="small" />
                            </Avatar>
                          )}
                        </ListItemAvatar>

                        <ListItemText
                          primary={
                            isImage ? (
                              <Typography
                                variant="body2"
                                className="text-blue underline cursor-pointer text-[11px]"
                                onClick={() => window.open(url, "_blank")}
                              >
                                Open Image
                              </Typography>
                            ) : (
                              <a
                                href={url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue underline text-[11px]"
                              >
                                Open File
                              </a>
                            )
                          }
                          secondary={
                            <Typography variant="caption" color="textSecondary" className="text-[10px] truncate max-w-[200px] block">
                              {url.split("/").pop()}
                            </Typography>
                          }
                          style={{ margin: 0 }}
                        />

                        <IconButton
                          size="small"
                          edge="end"
                          onClick={() => {
                            const updated = [...prevAttachments.attachments];
                            updated.splice(index, 1);
                            setPrevAttachments((prev) => ({
                              ...prev,
                              attachments: updated,
                            }));
                          }}
                          className="text-rose-500 hover:text-rose-700"
                        >
                          <Delete fontSize="small" />
                        </IconButton>
                      </ListItem>

                      {index < prevAttachments.attachments.length - 1 && (
                        <Divider className="my-1" />
                      )}
                    </Box>
                  );
                })}
              </List>
            ) : (
              <Typography variant="caption" color="textSecondary" align="center" className="py-4 block">
                No attachments found.
              </Typography>
            )}
          </DialogContent>
          <DialogActions style={{ padding: '8px 16px' }}>
            <Button
              size="small"
              onClick={() => setIsAttachmentModalOpen(false)}
              color="primary"
              style={{ textTransform: 'none' }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
    </form>
  );
};

export default VesselContractForm;
